import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './themes';
import { BrowserRouter } from 'react-router-dom';
import { UAT_OR_PROD } from './utils/constant';
import { setupMonitoring } from './monitoring';

setupMonitoring();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={UAT_OR_PROD}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
